"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AddressResponseMapper = void 0;
var AddressResponseMapper = /** @class */ (function () {
    function AddressResponseMapper(data) {
        this.localData = data;
    }
    AddressResponseMapper.prototype.getDataObject = function () {
        return this.localData;
    };
    return AddressResponseMapper;
}());
exports.AddressResponseMapper = AddressResponseMapper;
//# sourceMappingURL=AddressResponseMapper.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idse/checkout-ui/models/mappers/AddressResponseMapper.js
// module id = 2070
// module chunks = 8